import {
postersSetIndexMode,
        postersUnescapeSpacesAndApostrophes,
        } from "./posters.js";
import {
posterAppendAuthor,
        posterRender
        } from "./poster.js";
import { IfQuickReloadFlushEverything } from "./cache.js";
import {
        mapsGetRegionsForVegueria,
        mapsGetVegueriaForRegion,
        mapsLocalizePath,
        mapsPrefetchVegueries
        } from "./maps.js";
import {
pageFetchPosters,
        pageGetNextPageHref,
        pageGetNextPageIndex,
        pageGetPostersNumber,
        pageIsThereMorePosters
        } from "./page.js";
import { controlStartUp } from "./control.js";
import { labelsGetDisplayLabel } from "./labels.js";
import { i18nGetPageLanguage } from "./i18n.js";
import { empGetEditorUrl } from "./emp.js";
import { loadMoreBind } from "./load-more.js";

// function mainSetGetLabelCookie(label, labelName)
// {
//    if (label === null)
//    {
//        label = browserGetCookie(labelName);
//    } else
//    {
//        if (label !== "")
//        {
//            label = postersUnescapeSpacesAndApostrophes(label);
//        }
//        browserSetCookie(labelName, label, 1);
//    }
//    return(label);
// }

function mainGetString(param, label = null, unescape = true) {
    if (label) {
        param = label;
    }

    if (param === null) {
        return "";
    } else {
        if (unescape === true) {
            return postersUnescapeSpacesAndApostrophes(param);
        } else {
            return param;
        }
}
}

function mainGetOthersRegions(mainRegions, mainRegionDisplay, mainVegueria) {
    if (mainVegueria !== "") {
        return mapsGetRegionsForVegueria(mainVegueria);
    }

    let mainRegion = "";
    if (mainRegions.length === 1) {
        mainRegion = mainRegions[0];
    } else if (mainRegionDisplay !== "") {
        mainRegion = mainRegionDisplay;
    }

    if (mainRegion !== "") {
        const vegueria = mapsGetVegueriaForRegion(mainRegion);
        if (vegueria !== "") {
            return mapsGetRegionsForVegueria(vegueria);
        }
    }

    return "";
}

function mainGetOthersVegueria(mainRegions, mainRegionDisplay, mainVegueria) {
    if (mainVegueria !== "") {
        return mainVegueria;
    }

    let mainRegion = "";
    if (mainRegions.length === 1) {
        mainRegion = mainRegions[0];
    } else if (mainRegionDisplay !== "") {
        mainRegion = mainRegionDisplay;
    }

    if (mainRegion !== "") {
        return mapsGetVegueriaForRegion(mainRegion);
    }

    return "";
}

function mainIsVegueriaOnlyPage(mainLabel, mainTown, mainRegionDisplay, mainVegueria) {
    return (
            mainVegueria !== "" &&
            mainLabel === "" &&
            mainTown === "" &&
            mainRegionDisplay === ""
            );
}

function mainSetOthersTitle(vegueria) {
    const mainOtherPosters = document.getElementById("mainOtherPosters");
    if (mainOtherPosters === null) {
        return;
    }

    let filters = document.getElementById("mainOtherFilters");
    if (vegueria === "") {
        if (filters !== null) {
            filters.remove();
        }
        return;
    }

    if (filters === null) {
        filters = document.createElement("div");
        filters.setAttribute("id", "mainOtherFilters");

        const filter = document.createElement("div");
        filter.setAttribute("id", "mainOtherFilterVegueria");

        const subtitle = document.createElement("h2");
        subtitle.setAttribute("id", "mainOtherPostersVegueriaTitle");
        subtitle.setAttribute("class", "mainFilterText");

        const closeButton = document.createElement("a");
        closeButton.setAttribute("id", "mainOtherFilterAnchor");
        closeButton.setAttribute("class", "mainFilterAnchor");
        closeButton.setAttribute("href", mapsLocalizePath("/"));
        closeButton.textContent = "\u2a2f";

        filter.appendChild(subtitle);
        filter.appendChild(closeButton);
        filters.appendChild(filter);

        const title = mainOtherPosters.getElementsByTagName("h2")[0];
        if (title !== undefined && title !== null) {
            title.insertAdjacentElement("afterend", filters);
        } else {
            mainOtherPosters.prepend(filters);
        }
    }

    let subtitle = document.getElementById("mainOtherPostersVegueriaTitle");
    subtitle.textContent = vegueria;
}

function mainSyncMainNextPageWithOthers(otherHref) {
    const mainNextPageButton = document.getElementById("mainNextPageButton");
    const mainNextPageButtonWrapper =
            document.getElementById("mainNextPageButtonWrapper");

    if (
            mainNextPageButton === null ||
            mainNextPageButtonWrapper === null ||
            mainNextPageButtonWrapper.style.display === "none"
            ) {
        return;
    }

    const mainHref = mainNextPageButton.getAttribute("href");
    if (mainHref === null || mainHref === "") {
        return;
    }

    const mainUrl = new URL(mainHref, window.location.origin);
    const otherUrl = new URL(otherHref, window.location.origin);
    const otherIndex = otherUrl.searchParams.get("otherIndex");
    const otherCursor = otherUrl.searchParams.get("otherCursor");

    if (otherIndex !== null && otherIndex !== "") {
        mainUrl.searchParams.set("otherIndex", otherIndex);
    } else {
        mainUrl.searchParams.delete("otherIndex");
    }

    if (otherCursor !== null && otherCursor !== "") {
        mainUrl.searchParams.set("otherCursor", otherCursor);
    } else {
        mainUrl.searchParams.delete("otherCursor");
    }

    mainNextPageButton.setAttribute(
            "href",
            mainUrl.pathname + mainUrl.search
            );
}

function mainBindIncrementalButton({
    buttonId,
    wrapperId,
    mode,
    region,
    town,
    label,
    regionParam,
    indexParam,
    cursorParam,
    waitForWrapperId = null,
    afterLoad = null
}) {
    const button = document.getElementById(buttonId);
    const wrapper = document.getElementById(wrapperId);
    if (!button || !wrapper) {
        return;
    }

    loadMoreBind(button, async () => {
        if (waitForWrapperId) {
            const waitForWrapper = document.getElementById(waitForWrapperId);
            if (waitForWrapper && waitForWrapper.dataset.postersLoaded !== "true") {
                return;
            }
        }
        const href = button.getAttribute("href");
        if (!href) {
            return;
        }

        const nextUrl = new URL(href, window.location.origin);
        const index = parseInt(nextUrl.searchParams.get(indexParam), 10);
        const cursor = nextUrl.searchParams.get(cursorParam) || "";
        postersSetIndexMode(mode);

        await pageFetchPosters(
                wrapper,
                region,
                town,
                label,
                Number.isNaN(index) ? 0 : index,
                cursor,
                regionParam,
                {targetPostersNumber: 20}
                );

        const buttonWrapper = button.parentElement;
        if (pageIsThereMorePosters()) {
            const generatedUrl = new URL(
                    pageGetNextPageHref(indexParam, true, cursorParam),
                    window.location.origin
                    );
            nextUrl.searchParams.set(indexParam, generatedUrl.searchParams.get(indexParam));
            const generatedCursor = generatedUrl.searchParams.get(cursorParam);
            if (generatedCursor) {
                nextUrl.searchParams.set(cursorParam, generatedCursor);
            } else {
                nextUrl.searchParams.delete(cursorParam);
            }
            const nextHref = nextUrl.pathname + nextUrl.search;
            button.setAttribute("href", nextHref);
            if (buttonWrapper) {
                buttonWrapper.style.display = "block";
            }
            if (typeof afterLoad === "function") {
                afterLoad(nextHref);
            }
        } else {
            button.removeAttribute("href");
            if (buttonWrapper) {
                buttonWrapper.style.display = "none";
            }
        }
    });
}

async function mainStartUp(label = null, town = null, regions = null, vegueria = null) {
    let params = new URL(document.location).searchParams;
    let mainIndex = params.get("index") || 0;
    let otherIndex = parseInt(params.get("otherIndex"), 10);
    if (Number.isNaN(otherIndex)) {
        otherIndex = 0;
    }
    let mainLabel = mainGetString(params.get("label"), label);
    let mainTown = mainGetString(params.get("town"), town);
    let mainRegionParam = mainGetString(params.get("region"), null);
    let mainVegueria = mainGetString(null, vegueria);
    window.currentVegueria = mainVegueria;
    let mainRegions = Array.isArray(regions)
        ? regions.map(postersUnescapeSpacesAndApostrophes)
        : [];
    let mainRegionDisplay = "";
    let mainFlush = mainGetString(params.get("flush"));
    let mainCursor = mainGetString(params.get("cursor"), null, false);
    let otherCursor = mainGetString(params.get("otherCursor"), null, false);

    if (mainRegions.length === 0 && mainRegionParam !== "") {
        mainRegions = [mainRegionParam];
    }

    if (mainRegions.length === 1) {
        mainRegionDisplay = mainRegions[0];
    } else {
        mainRegionDisplay = mainRegionParam;
    }

    const hasRegionFilter = mainRegions.length > 0 || mainRegionParam !== "";
    // check that there is cursor cookie for the index
    //    if (posterIsThereCursorForTheIndex(mainIndex) === false)
    //    {
    //        window.location.replace("/");
    //        return;
    //    }

    // set region, erases town cookie
    if (hasRegionFilter && mainTown === null) {
        mainTown = "";
    }
    // set town erases region
    if (mainTown !== "" && mainTown !== null && mainRegionParam === null) {
        mainRegionParam = "";
    }

    // it is there a quick reload is flushed everything ---------------------
    if (await IfQuickReloadFlushEverything()) {
        return;
    }

    // page posters ----------------------------------------------------
    let mainPostersWrapper = document.getElementById("mainPostersWrapper");
    const hasMainFilter = mainLabel !== "" || mainTown !== "" || hasRegionFilter;
    const isVegueriaOnlyPage = mainIsVegueriaOnlyPage(
            mainLabel,
            mainTown,
            mainRegionDisplay,
            mainVegueria
            );
    if (mainPostersWrapper.dataset.postersLoaded === "false") {
        //
        document.getElementById("mainLoader").style.display = "inline-block";

        let mainRegionFilter =
                mainRegions.length > 0 ? mainRegions : mainRegionParam;

        const skipMainPosters =
                otherIndex > 0 &&
                hasMainFilter &&
                String(mainIndex) === "0" &&
                (mainCursor === null || mainCursor === "");

        if (skipMainPosters) {
            mainPostersWrapper.dataset.postersLoaded = "true";
            document.getElementById("mainLoader").style.display = "none";
            document.getElementById("mainNextPageButtonWrapper").style.display =
                    "none";
            if (isVegueriaOnlyPage) {
                _mainOthersPosters(0);
                return;
            }
            mapsPrefetchVegueries().finally(() => {
                const otherVegueria = mainGetOthersVegueria(
                        mainRegions,
                        mainRegionDisplay,
                        mainVegueria
                        );
                const otherRegions = mainGetOthersRegions(
                        mainRegions,
                        mainRegionDisplay,
                        mainVegueria
                        );
                _mainOthersPosters(20, otherRegions, otherVegueria);
            });
            return;
        }

        //
        postersSetIndexMode("main");
        mapsPrefetchVegueries().finally(() => {
            const otherVegueria = mainGetOthersVegueria(
                    mainRegions,
                    mainRegionDisplay,
                    mainVegueria
                    );
            const otherRegions = mainGetOthersRegions(
                    mainRegions,
                    mainRegionDisplay,
                    mainVegueria
                    );
            pageFetchPosters(
                    mainPostersWrapper,
                    mainRegionFilter,
                    mainTown,
                    mainLabel,
                    mainIndex,
                    mainCursor,
                    mainRegionDisplay,
                    {
                        forceFullPage: hasMainFilter,
                        targetPostersNumber: 20
                    }
                    )
                    .then(() => {
                    //
                    if (pageGetPostersNumber() === 0) {
                        let element = document.createElement("div");
                        element.setAttribute("id", "mainNoPostersMessage");
                        let text;
                        const language = i18nGetPageLanguage();
                        text = "No hi ha cartells";

                        if (mainLabel !== "") {
                            text += " amb l'etiqueta <b class='nowrap'>" + labelsGetDisplayLabel(mainLabel, language) + "</b>,";
                        }
                        if (mainTown !== "") {
                            text += " a <b class='nowrap'>" + mainTown + "</b>,";
                        }
                        if (mainRegionDisplay !== "") {
                            text += " a <b class='nowrap'>" + mainRegionDisplay + "</b>,";
                        }
                        text +=
                                " publica el teu cartell a " +
                                "<a class='nowrap' href='" + empGetEditorUrl() + "'> editor.yuppiya.com</a>";
                        element.innerHTML = text;
                        mainPostersWrapper.appendChild(element);
                    }
                    // next page button --------------------------------------------
                    if (pageIsThereMorePosters() === true) {
                        document.getElementById("mainNextPageButtonWrapper").style.display =
                                "block";
                        let nextHref = pageGetNextPageHref();
                        if (hasMainFilter) {
                            const nextUrl = new URL(nextHref, window.location.origin);
                            nextUrl.searchParams.set("otherIndex", String(otherIndex));
                            if (otherCursor !== "") {
                                nextUrl.searchParams.set("otherCursor", otherCursor);
                            } else {
                                nextUrl.searchParams.delete("otherCursor");
                            }
                            nextHref = nextUrl.pathname + nextUrl.search;
                        }
                        document
                                .getElementById("mainNextPageButton")
                                .setAttribute("href", nextHref);
                        mainBindIncrementalButton({
                            buttonId: "mainNextPageButton",
                            wrapperId: "mainPostersWrapper",
                            mode: "main",
                            region: mainRegionFilter,
                            town: mainTown,
                            label: mainLabel,
                            regionParam: mainRegionDisplay,
                            indexParam: "index",
                            cursorParam: "cursor",
                            waitForWrapperId: hasMainFilter
                                    ? "mainOtherPostersWrapper"
                                    : null
                        });
                    } else {
                        if (mainIndex !== 0) {
                            document.getElementById("mainNextPageButtonWrapper").style.display =
                                    "block";
                            document.getElementById("mainNextPageButton").textContent =
                                    "Pricipal";
                            document
                                    .getElementById("mainNextPageButton")
                                    .setAttribute("href", mapsLocalizePath("/"));
                        } else if (hasMainFilter) {
                            // document.getElementById('mainNextPageButtonWrapper').style.display = 'block';
                            // document.getElementById('mainNextPageButton').textContent = "Pricipal";
                            document.getElementById("mainNextPageButtonWrapper").style.display =
                                    "none";
                        } else {
                            document.getElementById("mainNextPageButtonWrapper").style.display =
                                    "none";
                        }
                    }

                    if (hasMainFilter) {
                        const otherTarget = Math.max(0, 20 - pageGetPostersNumber());
                        if (isVegueriaOnlyPage) {
                            _mainOthersPosters(0);
                        } else if (otherTarget > 0) {
                            _mainOthersPosters(otherTarget, otherRegions, otherVegueria);
                        } else {
                            _mainOthersPosters(0);
                        }
                    }
                    })
                    .catch((err) => {
                        console.log("Alguna cosa ha anat malament: " + err);
                        console.log(err.stack);                    
                    })
                    .finally(() => {
                        mainPostersWrapper.dataset.postersLoaded = "true";
                        document.getElementById("mainLoader").style.display = "none";
                    });
        });
    } else {
        // crawl version ------------------------------------------------------
        // rendering posters
        posterRender();

        // download publishers
        let auxPosters = mainPostersWrapper.getElementsByClassName("posterWrapper");
        [].forEach.call(auxPosters, (poster) => {
            posterAppendAuthor(poster);
        });
    }

// moved to the server
//    if (mainLabel !== "" || mainTown !== "" || mainRegion !== "") {
//        document.getElementById("mainFilters").style = "display: block;";
//}
}

function _mainOthersPosters(
        targetPostersNumber = 20,
        otherRegions = "",
        otherVegueria = ""
        ) {
    let mainOtherPosters = document.getElementById("mainOtherPosters");
    if (mainOtherPosters !== null) {
        let mainOtherPostersWrapper = document.getElementById(
                "mainOtherPostersWrapper"
                );
        if (targetPostersNumber <= 0) {
            mainOtherPosters.style = "display: none;";
            if (mainOtherPostersWrapper !== null) {
                mainOtherPostersWrapper.dataset.postersLoaded = "true";
            }
            return;
        }
        mainOtherPosters.style = "display: block;";
        mainSetOthersTitle(otherVegueria);

        //console.log("other ");

        controlStartUp("mainOtherSentinel");

        postersSetIndexMode("others");
        let params = new URL(document.location).searchParams;
        let otherIndex = parseInt(params.get("otherIndex"), 10);
        if (Number.isNaN(otherIndex)) {
            otherIndex = 0;
        }
        let otherCursor = mainGetString(params.get("otherCursor"), null, false);
        pageFetchPosters(
                mainOtherPostersWrapper,
                otherRegions,
                "",
                "",
                otherIndex,
                otherCursor,
                null,
                {
                    forceFullPage: true,
                    targetPostersNumber
                }
                ).then(
                () => {
            if (pageIsThereMorePosters() === true) {
                document.getElementById(
                        "mainOtherNextPageButtonWrapper"
                        ).style.display = "block";
                let otherHref = pageGetNextPageHref("otherIndex", true, "otherCursor");
                document
                        .getElementById("mainOtherNextPageButton")
                        .setAttribute("href", otherHref);
                mainSyncMainNextPageWithOthers(otherHref);
                mainBindIncrementalButton({
                    buttonId: "mainOtherNextPageButton",
                    wrapperId: "mainOtherPostersWrapper",
                    mode: "others",
                    region: otherRegions,
                    town: "",
                    label: "",
                    regionParam: null,
                    indexParam: "otherIndex",
                    cursorParam: "otherCursor",
                    afterLoad: mainSyncMainNextPageWithOthers
                });
            } else {
                document.getElementById(
                        "mainOtherNextPageButtonWrapper"
                        ).style.display = "none";
                document
                        .getElementById("mainOtherNextPageButton")
                        .removeAttribute("href");
            }
        }
        ).finally(() => {
            mainOtherPostersWrapper.dataset.postersLoaded = "true";
        });
    }
}

export { mainStartUp };
